<template>
  <div>
    <BaseHeadline :icon="icon">
      <template v-slot:headlineBtns>
        <v-btn color="primary" depressed @click="save">Opprett</v-btn>
      </template>
    </BaseHeadline>
    <BaseView v-model="list">
      <template v-slot="{ element }">
        <AberrationInfoCard
          ref="info"
          v-if="element.type === 'RUHInfoCard'"
          v-model="aberration"
          :type="aberrationTypes"
          :status="aberrationStatuses"
          :aberrationSeverities="aberrationSeverities"
          :aberrationCauses="aberrationCauses"
          :users="users"
          :categoryName="categoryName"
          :icon="icon"
          :titleLabel="titleLabel"
        />
        <AberrationProjectCard
          ref="project"
          v-if="element.type === 'RUHProjectCard'"
          v-model="aberration"
          :projects="projects"
          :aberrationLocations="aberrationLocations"
        />
        <AberrationAttachmentsCard
          v-if="element.type === 'RUHAttachmentsCard' && aberration"
          v-model="aberration.attachments"
        />
      </template>
    </BaseView>
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      class="mb-2"
      color="primary"
      large
      block
      depressed
      @click="save"
    >
      Opprett
    </v-btn>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";

import aberrationApi from "@/api/aberrationApi";
import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import BaseView from "@/components/shared/BaseView.vue";

import AberrationInfoCard from "@/components/aberration/new/children/AberrationInfoCard.vue";
import AberrationProjectCard from "@/components/aberration/new/children/AberrationProjectCard.vue";
import AberrationAttachmentsCard from "@/components/aberration/new/children/AberrationAttachmentsCard.vue";
import notification from "@/helpers/notification";

export default Vue.extend({
  props: {
    icon: {
      type: String,
    },
    aberrationCategory: {
      required: true,
      type: String,
    },
    categoryName: {
      type: String,
    },
    titleLabel: {
      type: String,
      default: "Hva har skjedd",
    },
  },
  data() {
    return {
      aberration: {},
      aberrationTypes: [],
      aberrationStatuses: [],
      aberrationSeverities: [],
      aberrationCauses: [],
      users: [],

      projects: [],
      aberrationLocations: [],
      list: {
        lg: [
          [{ type: "RUHInfoCard" }],
          [{ type: "RUHProjectCard" }],
          [{ type: "RUHAttachmentsCard" }],
        ],
        md: [
          [{ type: "RUHInfoCard" }],
          [{ type: "RUHProjectCard" }],
          [{ type: "RUHAttachmentsCard" }],
        ],
        sm: [
          [{ type: "RUHInfoCard" }],
          [
            { type: "RUHProjectCard" },
            { type: "RUHAttachmentsCard" },
            { type: "CreateBtn" },
          ],
        ],
        xs: [
          [
            { type: "RUHInfoCard" },
            { type: "RUHProjectCard" },
            { type: "RUHAttachmentsCard" },
            { type: "CreateBtn" },
          ],
        ],
      },
    };
  },
  created() {
    //aberrationId -1 is new
    //category
    //1 = avvik
    //2 = RUH
    const data = {
      aberrationId: "-1",
      category: this.aberrationCategory,
      projectId: this.$route.query.projectId,
    };
    aberrationApi.getAberration(data).then((r) => {
      this.aberration = r.aberration;
      this.aberrationTypes = r.aberrationTypes;
      this.aberrationStatuses = r.aberrationStatuses;
      this.aberrationSeverities = r.aberrationSeveritiesList;
      this.aberrationCauses = r.aberrationCauses;
      this.users = r.users;
      this.projects = r.projects;
      this.aberrationLocations = r.aberrationLocationsList;
      (this as any).aberration.timeLimit = moment().add(14, "days");

      if (this.$route.query.houseId) {
        (this as any).aberration.projPhase = parseInt(
          (this as any).$route.query.houseId
        );
      }
    });
  },
  methods: {
    save() {
      var validateInfo = (this as any).$refs.info.validate();
      var validateProject = (this as any).$refs.project.validate();

      if (validateInfo && validateProject) {
        this.$emit("save", this.aberration);
      } else {
        notification.warn("Alle obligatoriske felter må fylles ut!");
      }
    },
  },

  components: {
    BaseView,
    BaseHeadline,
    AberrationInfoCard,
    AberrationProjectCard,
    AberrationAttachmentsCard,
  },
});
</script>
